<template>
  <v-container fluid>
    <v-row class="mb-1">
      <v-col>
        <h2>
          <v-icon class="mr-2">
            mdi-list-status
          </v-icon>
          １次２次紐付け
        </h2>
      </v-col>
    </v-row>

    <!-- 検索項目 -->
    <v-expansion-panels
      v-model="panels"
      accordion
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="panel-header-color panel-selectable">
          <strong>
            <v-icon class="panel-header-color">
              mdi-magnify
            </v-icon>
            &nbsp;条件を指定して検索
          </strong>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <validation-observer ref="linkagesConditionValidate">
            <v-card flat>
              <v-card-text>
                <!-- 処分事業者, 処分事業場 -->
                <infinite-tenant-trader-and-location-auto-complete
                  :trader-id="conditions.disposer_id"
                  :location-id="conditions.disposer_location_id"
                  :location-code="conditions.disposer_location_code"
                  search-type="trader"
                  rounded
                  trader-md="4"
                  location-md="4"
                  classes="search-font"
                  trader-label="処分事業者"
                  location-label="処分事業場"
                  trader-required
                  location-required
                  location-auto-select
                  @update:values="disposerChangedCallback"
                >
                  <template v-slot:trader-append-outer>
                    <v-btn
                      small
                      class="primary"
                      @click="enableSearchDisposerDialog=true"
                    >
                      処分事業場を選択
                    </v-btn>
                  </template>
                </infinite-tenant-trader-and-location-auto-complete>
                <!-- /処分事業者, 処分事業場 -->

                <v-row>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="conditions.disposal_category_codes"
                      :items="afterDisposalItemCategories"
                      class="search-font"
                      clearable
                      dense
                      item-text="text"
                      item-value="value"
                      label="処理後物の大分類名称"
                      multiple
                      hide-details="auto"
                      persistent-placeholder
                      rounded
                      outlined
                      @change="afterDisposalItemCategoryChange"
                    >
                      <template v-slot:item="{ item, on, attrs }">
                        <v-list-item
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-list-item-action
                          >
                            <v-simple-checkbox
                              :value="isCategorySelected(item)"
                              :input-value="isCategorySelected(item)"
                              @click="categoryClick(item)"
                            />
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-chip
                                small
                                :color="item.after_type === 'after_industrial' ? 'light-blue lighten-4' : 'light-green lighten-4'"
                              >
                                {{ item.after_type === 'after_industrial' ? '廃棄物' : '再資源' }}
                              </v-chip>
                              <span class="ml-3">{{ item.text }}</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>

                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="conditions.disposal_subcategory_ids"
                      :items="afterDisposalItemSubcategories"
                      class="search-font"
                      clearable
                      dense
                      item-text="text"
                      item-value="value"
                      label="処理後物の種類"
                      multiple
                      hide-details="auto"
                      persistent-placeholder
                      rounded
                      outlined
                      @change="searchButtonClickEvent"
                      @click:clear="clearAfterDisposalItemSubCategories"
                    >
                      <template v-slot:item="{ item, on, attrs }">
                        <v-list-item
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-list-item-action
                          >
                            <v-simple-checkbox
                              :value="isSubSelected(item)"
                              :input-value="isSubSelected(item)"
                              @click="subcategoryClick(item)"
                            />
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.code }}:{{ item.text }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <item-autocomplete
                      v-model="conditions.item_ids"
                      :items="items"
                      classes="search-font"
                      clearable
                      dense
                      label="JWNET品目"
                      persistent-placeholder
                      outlined
                      rounded
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      @change="searchButtonClickEvent"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="conditions.second_consign"
                      class="search-font"
                      label="２次委託量"
                      outlined
                      rounded
                      dense
                      persistent-placeholder
                      type="number"
                      hide-details="auto"
                      @blur="searchButtonClickEvent"
                      @click:clear="conditions.second_consign = null; searchButtonClickEvent()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="2">
                    <cs-date-picker
                      :date.sync="conditions.collected_date_from"
                      @dateChangedCallback="collectedDateFromChangedCallback"
                    >
                      <template v-slot="{ on, attrs }">
                        <v-text-field
                          v-model="conditions.collected_date_from"
                          v-bind="attrs"
                          v-on="on"
                          append-icon="mdi-calendar"
                          class="search-font"
                          clearable
                          dense
                          hide-details="auto"
                          label="引渡し日 (from)"
                          outlined
                          persistent-placeholder
                          placeholder="日付を選択"
                          readonly
                          rounded
                          @click:clear="conditions.collected_date_from = null; searchButtonClickEvent()"
                        >
                          <template v-slot:append-outer>
                            <div
                              v-if="$vuetify.breakpoint.mdAndUp"
                              style="vertical-align: middle"
                            >
                              〜
                            </div>
                          </template>
                        </v-text-field>
                      </template>
                    </cs-date-picker>
                  </v-col>
                  <v-col cols="12" md="2">
                    <cs-date-picker
                      :date.sync="conditions.collected_date_to"
                      @dateChangedCallback="collectedDateToChangedCallback"
                    >
                      <template v-slot="{ on, attrs }">
                        <v-text-field
                          v-model="conditions.collected_date_to"
                          v-bind="attrs"
                          v-on="on"
                          append-icon="mdi-calendar"
                          class="search-font"
                          clearable
                          dense
                          hide-details="auto"
                          label="引渡し日 (to)"
                          outlined
                          persistent-placeholder
                          placeholder="日付を選択"
                          readonly
                          rounded
                          @click:clear="conditions.collected_date_to = null; searchButtonClickEvent()"
                        />
                      </template>
                    </cs-date-picker>
                  </v-col>
                  <v-col cols="12" md="2">
                    <cs-date-picker
                      :date.sync="conditions.disposal_completed_date_from"
                      @dateChangedCallback="disposalCompletedDateFromChangedCallback"
                    >
                      <template v-slot="{ on, attrs }">
                        <v-text-field
                          v-model="conditions.disposal_completed_date_from"
                          v-bind="attrs"
                          v-on="on"
                          append-icon="mdi-calendar"
                          class="search-font"
                          clearable
                          dense
                          hide-details="auto"
                          label="処分終了日 (from)"
                          outlined
                          persistent-placeholder
                          placeholder="日付を選択"
                          readonly
                          rounded
                          @click:clear="conditions.disposal_completed_date_from= null; searchButtonClickEvent()"
                        >
                          <template v-slot:append-outer>
                            <div
                              v-if="$vuetify.breakpoint.mdAndUp"
                              style="vertical-align: middle"
                            >
                              〜
                            </div>
                          </template>
                        </v-text-field>
                      </template>
                    </cs-date-picker>
                  </v-col>
                  <v-col cols="12" md="2">
                    <cs-date-picker
                      :date.sync="conditions.disposal_completed_date_to"
                      @dateChangedCallback="disposalCompletedDateToChangedCallback"
                    >
                      <template v-slot="{ on, attrs }">
                        <v-text-field
                          v-model="conditions.disposal_completed_date_to"
                          v-bind="attrs"
                          v-on="on"
                          append-icon="mdi-calendar"
                          class="search-font"
                          clearable
                          dense
                          hide-details="auto"
                          label="処分終了日 (to)"
                          outlined
                          persistent-placeholder
                          placeholder="日付を選択"
                          readonly
                          rounded
                          @click:clear="conditions.disposal_completed_date_to = null; searchButtonClickEvent()"
                        />
                      </template>
                    </cs-date-picker>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select
                      v-model="conditions.disposal_method_id"
                      :items="disposalMethods"
                      class="search-font"
                      label="処分方法"
                      clearable
                      hide-details="auto"
                      outlined
                      multiple
                      rounded
                      dense
                      persistent-placeholder
                      @change="searchButtonClickEvent"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select
                      v-model="conditions.recycling"
                      :items="recyclingTypes"
                      class="search-font"
                      clearable
                      dense
                      hide-details="auto"
                      label="リサイクル希望"
                      outlined
                      persistent-placeholder
                      rounded
                      @change="searchButtonClickEvent"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="conditions.waste_name"
                      background-color="white"
                      class="search-font"
                      clearable
                      dense
                      hide-details="auto"
                      label="廃棄物の名称"
                      outlined
                      rounded
                      persistent-placeholder
                      @blur="searchButtonClickEvent()"
                      @click:clear="conditions.waste_name = null; searchButtonClickEvent()"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="conditions.manifest_type"
                      :items="manifestTypes"
                      class="search-font"
                      clearable
                      background-color="white"
                      dense
                      hide-details="auto"
                      label="マニフェスト区分"
                      outlined
                      persistent-placeholder
                      rounded
                      @change="searchButtonClickEvent"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="conditions.manifest_ids"
                      class="search-font"
                      clearable
                      dense
                      hide-details="auto"
                      label="DXEマニ番号"
                      outlined
                      persistent-hint
                      persistent-placeholder
                      rounded
                      placeholder="DXEマニ番号をカンマ区切りで入力"
                      hint="例: 1, 2, 3"
                      @blur="searchButtonClickEvent"
                      @click:clear="conditions.manifest_ids = null; searchButtonClickEvent()"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select
                      v-model="conditions.sort_type"
                      :items="sortTypes"
                      class="search-font"
                      dense
                      hide-details="auto"
                      label="表示順"
                      outlined
                      persistent-placeholder
                      rounded
                      @change="searchButtonClickEvent"
                    />
                  </v-col>
                </v-row>

                <template v-if="isJwMode">
                  <!-- カスタムラベル -->
                  <v-row>
                    <v-col v-if="customLabel.custom_labels1_use" cols="12" md="2" >
                      <v-text-field
                        v-model="conditions.custom_labels_1"
                        :label="customLabel.custom_labels1_name"
                        class="search-font"
                        clearable
                        dense
                        hide-details="auto"
                        outlined
                        persistent-placeholder
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="conditions.custom_labels_1 = null; searchButtonClickEvent()"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col v-if="customLabel.custom_labels2_use" cols="12" md="2">
                      <v-text-field
                        v-model="conditions.custom_labels_2"
                        :label="customLabel.custom_labels2_name"
                        class="search-font"
                        clearable
                        dense
                        hide-details="auto"
                        outlined
                        persistent-placeholder
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="conditions.custom_labels_2 = null; searchButtonClickEvent()"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col v-if="customLabel.custom_labels3_use" cols="12" md="2">
                      <v-text-field
                        v-model="conditions.custom_labels_3"
                        :label="customLabel.custom_labels3_name"
                        class="search-font"
                        clearable
                        dense
                        hide-details="auto"
                        outlined
                        persistent-placeholder
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="conditions.custom_labels_3 = null; searchButtonClickEvent()"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col v-if="customLabel.custom_labels4_use" cols="12" md="2">
                      <v-text-field
                        v-model="conditions.custom_labels_4"
                        :label="customLabel.custom_labels4_name"
                        class="search-font"
                        clearable
                        dense
                        hide-details="auto"
                        outlined
                        persistent-placeholder
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="conditions.custom_labels_4 = null; searchButtonClickEvent()"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col v-if="customLabel.custom_labels5_use" cols="12" md="2">
                      <v-text-field
                        v-model="conditions.custom_labels_5"
                        :label="customLabel.custom_labels5_name"
                        class="search-font"
                        clearable
                        dense
                        hide-details="auto"
                        outlined
                        persistent-placeholder
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="conditions.custom_labels_5 = null; searchButtonClickEvent()"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col v-if="customLabel.custom_labels6_use" cols="12" md="2">
                      <v-text-field
                        v-model="conditions.custom_labels_6"
                        :label="customLabel.custom_labels6_name"
                        class="search-font"
                        clearable
                        dense
                        hide-details="auto"
                        outlined
                        persistent-placeholder
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="conditions.custom_labels_6 = null; searchButtonClickEvent()"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <!-- /カスタムラベル -->

                  <!-- カスタムラベル 未入力データのみ検索 -->
                  <v-row>
                    <v-col v-if="customLabel.custom_labels1_use" cols="12" md="2" >
                      <v-checkbox
                        v-model="conditions.custom_labels_1_unregistered"
                        label="未入力データのみ検索"
                        dense
                        hide-details="auto"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>

                    <v-col v-if="customLabel.custom_labels2_use" cols="12" md="2">
                      <v-checkbox
                        v-model="conditions.custom_labels_2_unregistered"
                        label="未入力データのみ検索"
                        dense
                        hide-details="auto"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>

                    <v-col v-if="customLabel.custom_labels3_use" cols="12" md="2">
                      <v-checkbox
                        v-model="conditions.custom_labels_3_unregistered"
                        label="未入力データのみ検索"
                        dense
                        hide-details="auto"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>

                    <v-col v-if="customLabel.custom_labels4_use" cols="12" md="2">
                      <v-checkbox
                        v-model="conditions.custom_labels_4_unregistered"
                        label="未入力データのみ検索"
                        dense
                        hide-details="auto"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>

                    <v-col v-if="customLabel.custom_labels5_use" cols="12" md="2">
                      <v-checkbox
                        v-model="conditions.custom_labels_5_unregistered"
                        label="未入力データのみ検索"
                        dense
                        hide-details="auto"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>

                    <v-col v-if="customLabel.custom_labels6_use" cols="12" md="2">
                      <v-checkbox
                        v-model="conditions.custom_labels_6_unregistered"
                        label="未入力データのみ検索"
                        dense
                        hide-details="auto"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                  </v-row>
                  <!-- /カスタムラベル 未入力データのみ検索 -->
                </template>

                <v-row dense>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="conditions.manifest_search_keyword"
                      dense
                      hide-details="auto"
                      label="マニフェスト検索キーワード"
                      clearable
                      outlined
                      persistent-placeholder
                      persistent-hint
                      rounded
                      style="font-size: 80%"
                      @blur="searchButtonClickEvent"
                      @click:clear="conditions.manifest_search_keyword = null; searchButtonClickEvent()"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-checkbox
                      v-model="conditions.with_associated"
                      dense
                      class="mt-2"
                      hide-details="auto"
                      label="紐付きのあるマニフェストを含める"
                      @change="searchButtonClickEvent"
                    />
                  </v-col>
                </v-row>

              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary"
                  @click="searchButtonClickEvent"
                >
                  <v-icon>
                    mdi-magnify
                  </v-icon>
                  &nbsp;検索
                </v-btn>
              </v-card-actions>
            </v-card>
          </validation-observer>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- /検索項目 -->

    <v-row class="mt-1">
      <v-col cols="12" md="2">
        <div class="fieldsetLabel">
          <fieldset>
            <legend class="text-right">
              選択件数
            </legend>
            <span class="text-right">{{ selectedMembers.length }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
      <v-col cols="12" md="2">
        <div class="fieldsetLabel">
          <fieldset>
            <legend class="text-right">
              数量合計
            </legend>
            <span class="text-right">{{ quantityTotal | comma_format }}&nbsp;</span>
          </fieldset>
        </div>
      </v-col>
      <v-col>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="enableCallLinkageButton"
            class="primary"
            @click="callLinkageButtonClickEvent"
          >
            ２次マニフェスト作成
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          :page-options="pageOptions"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <!-- 一覧 -->
    <v-sheet class="mt-5 mb-5" rounded>
      <v-data-table
        v-model="rowSelected"
        :headers="tableHeaders"
        :items="linkages"
        :items-per-page="-1"
        disable-sort
        hide-default-footer
        show-select
        @toggle-select-all="selectedAllCheckboxClickEvent($event)"
        @click:row="toggleRowSelection"
      >
        <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
          <v-simple-checkbox
            v-model="item.selected"
            :value="isSelected"
            @input="select($event)"
            @click="checkboxClickEvent(item)"
          />
        </template>
        <!-- マニフェスト番号 -->
        <template v-slot:[`item.manifest_no`]="{item}">
          <div>{{ item.manifest_no }}&nbsp;</div>
          <div>
            <small class="text--disabled">{{ item.manifest_type | manifest_type_to_label }}</small>
          </div>
        </template>
        <template v-slot:[`item.id`]="{item}">
          <div>{{ item.manifest_id }}&nbsp;</div>
        </template>
        <template v-slot:[`item.collected_date`]="{item}">
          {{ item.collected_date | date_format }}
        </template>
        <template v-slot:[`item.disposal_report_end_date`]="{item}">
          {{ item.disposal_report_end_date | date_format }}
        </template>
        <template v-slot:[`item.emission_name`]="{item}">
          <div class="line-clamp one-clamp">
            {{ item.emission_name }}
            <v-icon
              v-if="item.use_recycle"
              class="green--text"
            >
              mdi-recycle
            </v-icon>
          </div>
        </template>
        <template v-slot:[`item.item_name`]="{item}">
          <div>
            <v-chip
              :title="item.item_name"
              color="#F0E6D0"
              drak
              label
              x-small
            >
              {{ item.item_name | truncate(10) }}
            </v-chip>
          </div>
        </template>
        <template v-slot:[`item.quantity`]="{item}">
          <div v-if="item.quantity">
            {{ item.quantity | comma_format }}&nbsp;{{ item.quantity_unit_name }}
          </div>
        </template>
      </v-data-table>
    </v-sheet>
    <!-- /一覧 -->

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          :page-options="pageOptions"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <v-dialog v-model="enableWarningDialog" persistent width="700">
      <v-card>
        <v-card-title class="text-h5 red darken-2 white--text">
          確認
        </v-card-title>
        <v-divider />
        <v-card-text>
          <h4 class="mt-4">
            {{ warningDialogMessage }}
          </h4>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="enableWarningDialog = false"> 閉じる </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <search-tenant-disposer-dialog
      :enable-dialog="enableSearchDisposerDialog"
      @cancelCallback="searchDialogCancelCallback"
      @registerCallback="choseDisposerCallback"
    />
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import SearchTenantDisposerDialog from "@/driver/pages/dialogs/_SearchTenantDisposerDialog.vue";
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import InfiniteTenantTraderAndLocationAutoComplete
  from "@/driver/components/InfiniteTenantTraderAndLocationAutoComplete.vue";
import ItemAutocomplete from "@/driver/components/ItemAutocomplete.vue";

export default {
  name: 'DriverManifestLinkages',
  components: {
    InfiniteTenantTraderAndLocationAutoComplete,
    CustomPagination,
    SearchTenantDisposerDialog,
    ItemAutocomplete,
  },
  mixins: [],
  props: {},
  data() {
    return {
      panels: [],
      page: 1,
      perPage: 50,
      totalVisible: 7,
      disabledCount: 0,
      // ページネーションの表示件数選択肢
      pageOptions: [15,30,50,100,200,300],
      selectedButton: null,
      conditions: {
        disposer_id: null,
        disposer_location_id: null,
        disposer_location_code: null,
        disposal_category_codes: [],
        disposal_subcategory_ids: [],
        item_ids: null,
        second_consign: null,
        collected_date_from: null,
        collected_date_to: null,
        disposal_completed_date_from: null,
        disposal_completed_date_to: null,
        disposal_method_id: null,
        recycling: null,
        waste_name: null,
        manifest_type: null,
        manifest_ids: null,
        sort_type: 'collected_date_desc',
        custom_labels_1: null,
        custom_labels_2: null,
        custom_labels_3: null,
        custom_labels_4: null,
        custom_labels_5: null,
        custom_labels_6: null,
        custom_labels_1_unregistered: false,
        custom_labels_2_unregistered: false,
        custom_labels_3_unregistered: false,
        custom_labels_4_unregistered: false,
        custom_labels_5_unregistered: false,
        custom_labels_6_unregistered: false,
        manifest_search_keyword: null,
        with_associated: false,
      },
      recyclingTypes: [
        { value: 'not_including', text: '含まない'},
        { value: 'request_only', text: 'リサイクル希望のみ'}
      ],
      /** マニフェスト区分 */
      manifestTypes: [
        { value: 'dxe_form', text: '電子マニフェスト(EDI)' },
        { value: 'other_form', text: '電子マニフェスト(WEB)' },
        { value: 'paper_form', text: '紙マニフェスト' },
        { value: 'transfer_form', text: '電子マニフェスト(取込)' },
      ],
      tableHeaders: [
        { value: 'manifest_no', text: 'マニフェスト番号' },
        { value: 'id', text: 'DXEマニ番号' },
        { value: 'collected_date', text: '引渡日' },
        { value: 'disposal_report_end_date', text: '処分終了日' },
        { value: 'emission_name', text: '排出事業者' },
        { value: 'emission_location_name', text: '排出事業場' },
        { value: 'item_name', text: '品目' },
        { value: 'after_item_name', text: '処理後物の種類' },
        { value: 'quantity', text: '数量' },
        { value: 'disposal_method_name', text: '処分方法' },
        // { value: 'quantity', text: '数量' },
        // { value: 'disposal_method_name', text: '処分方法' },
      ],
      /** 表示順 */
      sortTypes: [
        { value: 'collected_date_desc', text: '引渡日（降順）▼' },
        { value: 'collected_date_asc', text: '引渡日（昇順）▲' },
      ],
      linkages: [],
      enableWarningDialog: false,
      warningDialogMessage: null,
      rowSelected: [],
      totalQuantity: null,
      selectedIds: [],
      disposalMethods: null,
      items: null,
      initialSearch: false,
      enableSearchDisposerDialog: false,
      customLabel: null,
      selectedDisposerIds: [],
      afterDisposalItemCategories: [],
      afterDisposalItemSubcategories: [],
    }
  },
  computed: {
    ...mapState('DriverManifestLinkage', {
      pagination: 'pagination',
      condition: 'condition',
      selectedItems: 'selectedItems',
      checkedTargetResults: 'checkedTargetResults',
    }),
    ...mapGetters('DriverManifestLinkage', [
      'selectedMembers',
      'quantityTotal'
    ]),
    ...mapState('DriverTenantConfiguration', {
      isJwMode: 'use_jw_mode',
    }),
    enableCallLinkageButton () {
      return !(this.linkages.length > 0 && this.selectedMembers.length > 0)
    },
  },
  watch: {
    selectedButton () {
      this.searchButtonClickEvent()
    },
  },
  created() {
    /* 別画面からの遷移時は値リセット */
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    if (this.$route.params.resetCheckable) {
      this.resetPagination()
    }
    if (this.$route.params.resetCheckable) {
      this.resetCheckable()
    }
    Object.assign(this.conditions, this.condition)
    this.page = this.pagination.current_page
    this.perPage = this.condition.limit

    if (this.conditions.disposer_id) {
      this.searchLinkages()
    } else {
      this.panels = 0;
    }
    this.fetchItems().then((content) => {
      this.items = content.items
    })
    this.fetchDisposalMethods().then((content) => {
      this.disposalMethods = content.disposal_methods
    })
    this.fetchCustomLabel().then((content) => {
      this.customLabel = content
    })
    this.loadAfterDisposalOptions()
  },
  methods: {
    ...mapActions('DriverManifestLinkage', {
      fetchLinkages: 'index',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
      receiveRegister: 'create',
      resetCheckable: 'allRemoveItems',
      setIndividualItem: 'setIndividualItem',
      removeIndividualItem: 'removeIndividualItem',
      setCheckedTargetResults: 'setCheckedTargetResults',
      removeItem: 'removeItem',
      allRemoveItems: 'allRemoveItems',
    }),
    ...mapActions("DriverManifestLinkageVerification", {
      verification: "show",
    }),
    /* JWNET品目 */
    ...mapActions('DriverMasterSearchItem', {
      fetchItems: 'index',
    }),
    /** 処分方法 */
    ...mapActions('DriverMasterSearchDisposalMethod', {
      fetchDisposalMethods: 'index',
    }),
    ...mapActions('DriverMasterSearchCustomLabel', {
      fetchCustomLabel: 'index',
    }),

    /**
     * 処理後物の大分類
     */
    ...mapActions("DriverMasterSearchRecycleDisposedItemCategory", {
      fetchItemCategories: 'index',
    }),

    ...mapActions("DriverMasterSearchRecycleDisposedItemSubcategory", {
      fetchItemSubcategories: 'index',
    }),

    /**
     * 処分事業者 チェンジコールバック
     * @param id { Number } 処分事業者ID
     */
    disposerChangedCallback (trader_id, location_id, location_code) {

      let changed = false;

      if (this.conditions.disposer_id !== trader_id) {
        changed = true;
      }

      if (this.conditions.disposer_location_id !== location_id) {
        changed = true;
      }

      this.conditions.disposer_id = trader_id;
      this.conditions.disposer_location_id = location_id;
      this.conditions.disposer_location_code = location_code;

      // クリアされた場合は一覧もクリア（処分事業者または処分事業場がnullの場合）
      if (trader_id === null || location_id === null) {
        this.linkages = [];
        this.rowSelected = [];
        this.allRemoveItems();
        return;
      }

      // 値が変更された場合は検索を実行
      if (changed) {
        this.$nextTick(() => { this.searchButtonClickEvent() });
      }

    },
    /**
     * 排出事業者検索モーダル 反映ボタンコールバック処理
     * @param item
     */
    choseDisposerCallback (item) {
      this.conditions.disposer_id = item.id;
      this.conditions.disposer_location_id = item.location.id;
      this.conditions.disposer_location_code = item.location.code;
      this.$nextTick(() => { this.searchButtonClickEvent() });
      this.searchDialogCancelCallback()
    },
    /**
     * ２次マニフェスト作成ボタン クリックイベント
     */
    callLinkageButtonClickEvent () {
      this.selectedIds = []
      // for (const manifest_id of this.selectedMembers) {
      for (const manifest_key of this.selectedMembers) {
        // this.selectedIds.push(manifest_id)
        this.selectedIds.push(manifest_key)
      }
      const params = {
        ids: this.selectedIds.join(","),
      };
      this.verification({ params: params }).then((content) => {
        if (content.status === "success") {
          this.$router.push({name: 'DriverManifestLinkageNew', query: { disposer_id: this.conditions.disposer_id, disposer_location_code: this.conditions.disposer_location_code }})
        } else {
          // エラー出す
          this.warningDialogMessage = content.error_message;
          this.enableWarningDialog = true;
        }
      });

    },
    /**
     * 行選択トグル
     */
    toggleRowSelection(item) {

      const index = this.rowSelected.findIndex(row => row === item);
      if (index > -1) {
        // 既に選択されている場合は削除
        this.rowSelected.splice(index, 1);
        item.selected = false;
        this.removeItem({item: item});
      } else {
        // 選択されていない場合は追加
        this.rowSelected.push(item);
        item.selected = true;
        this.setIndividualItem({item: item});
      }
    },
    /**
     * チェックボックス クリックイベント
     */
    checkboxClickEvent (item) {
      if (item.selected) {
        this.setIndividualItem({item: item})
      } else {
        this.removeItem({item: item})
      }
    },
    /**
     * チェックボックスの一括切替 クリックイベント
     */
    selectedAllCheckboxClickEvent (selectedItems) {

      let items = selectedItems.items
      let isSelected = selectedItems.value
      if (isSelected) {
        for (let item of items) {
          item.selected = true
          this.setIndividualItem({item: item})
        }
      } else {
        for (let item of items) {
          this.rowSelected = null;
          this.rowSelected = [];
          this.allRemoveItems()
          item.selected = false
        }
      }
    },
    /**
     * 引渡し日(from)変更　コールバック
     */
    collectedDateFromChangedCallback (value) {
      this.conditions.collected_date_from = value;
      this.searchButtonClickEvent();
    },
    /**
     * 引渡し日(to)変更　コールバック
     */
    collectedDateToChangedCallback (value) {
      this.conditions.collected_date_to = value;
      this.searchButtonClickEvent();
    },
    /**
     * 処分終了日 (from)変更　コールバック
     */
    disposalCompletedDateFromChangedCallback (value) {
      this.conditions.disposal_completed_date_from = value;
      this.searchButtonClickEvent();
    },
    /**
     * 処分終了日 (to)変更　コールバック
     */
    disposalCompletedDateToChangedCallback (value) {
      this.conditions.disposal_completed_date_to = value;
      this.searchButtonClickEvent();
    },

    // 大分類の選択肢を取得し、続けて種類の選択肢も取得する
    loadAfterDisposalOptions () {
      this.fetchItemCategories({
        disable_pagination: true,
      }).then((content) => {
        this.afterDisposalItemCategories = content.after_disposal_items || []
        return this.loadDisposedTypeOptions()
      })
    },
    // 選択中の大分類に紐づく種類の選択肢を取得する（大分類未選択時はクリア）
    loadDisposedTypeOptions () {
      if (this.conditions.disposal_category_codes.length <= 0) {
        this.afterDisposalItemSubcategories = []
        this.conditions.disposal_subcategory_ids = []
        return Promise.resolve()
      }
      this.fetchItemSubcategories({
        disposal_category_codes: this.conditions.disposal_category_codes
      }).then((content) => {
        this.afterDisposalItemSubcategories = content.after_disposal_items || []
      })
    },

    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.$refs.linkagesConditionValidate.validate().then((result) => {
        if(result) {
          this.rowSelected = null;
          this.rowSelected = [];
          this.initialSearch = true
          this.page = 1
          this.allRemoveItems()
          this.searchLinkages()
        }
      })
    },
    /**
     * 検索
     */
    searchLinkages () {
      let params = this.buildParam()
      // ２次委託量
      this.setCheckedTargetResults({items: []})

      this.fetchLinkages({ conditions: params }).then((content) => {
        this.linkages = content.manifests
        // this.linkages = content.manifest_recycle_disposal_reports
        // 検索ボタンクリックで入った場合はサーバで計算した結果を格納

        if (this.initialSearch) {
          // 初回検索時に取得した２次委託量に含まれるマニフェスト情報をセット
          // this.setCheckedTargetResults({items: content.checked_manifests})
          this.setCheckedTargetResults({items: content.checked_manifest_recycle_disposal_reports})
          this.initialSearch = false
        }

        // 一覧のチェック状態を設定
        // for (const manifest_id of this.selectedMembers) {
        for (const manifest_key of this.selectedMembers) {
          // let target = this.linkages.find((v) => v.id === manifest_id)
          let target = this.linkages.find((v) => v.id === manifest_key)
          if (target) {
            target.selected = true
          }
        }

      })
    },
    /**
     * 検索パラメータの生成
     */
    buildParam () {
      return {
        ...this.conditions,
        initial_search:this.initialSearch,
        type_of_manifest: 'first_manifest',
        final_report_state: 'unreported',
        page: this.page,
        limit: this.perPage,
      }
    },

    /**
     * ページ チェンジイベント
     */
    changePage(page) {
      this.page = page;
      this.searchLinkages()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchLinkages()
    },
    /**
     * 排出事業者検索モーダル 閉じるボタンコールバック処理
     */
    searchDialogCancelCallback () {
      this.enableSearchDisposerDialog = false
    },
    categoryClick(item) {

      if (this.conditions.disposal_category_codes.includes(item.value)) {
        this.conditions.disposal_category_codes = this.conditions.disposal_category_codes.filter(v => v !== item.value)
      } else {
        this.conditions.disposal_category_codes.push(item.value)
      }
      this.afterDisposalItemCategoryChange();
    },
    subcategoryClick (item) {
      if (this.conditions.disposal_subcategory_ids.includes(item.value)) {
        this.conditions.disposal_subcategory_ids = this.conditions.disposal_subcategory_ids.filter(v => v !== item.value)
      } else {
        this.conditions.disposal_subcategory_ids.push(item.value)
      }
      this.searchButtonClickEvent()
    },
    isCategorySelected(item) {
      return Array.isArray(this.conditions.disposal_category_codes)
        && this.conditions.disposal_category_codes.includes(item.value)
    },

    isSubSelected(item) {
      return Array.isArray(this.conditions.disposal_subcategory_ids)
        && this.conditions.disposal_subcategory_ids.includes(item.value)
    },

    afterDisposalItemCategoryChange () {
      this.loadDisposedTypeOptions()
      this.searchButtonClickEvent()
    },

    clearAfterDisposalItemSubCategories() {
      this.conditions.disposal_subcategory_ids = []
      this.searchButtonClickEvent()
    },
  }
}
</script>
